document.addEventListener('DOMContentLoaded', () => {
  const quantityWrappers = document.querySelectorAll('[data-quantity-wrapper]');
  
  quantityWrappers.forEach(wrapper => {
    const input = wrapper.querySelector('[data-quantity-input]');
    const decreaseBtn = wrapper.querySelector('[data-quantity-decrease]');
    const increaseBtn = wrapper.querySelector('[data-quantity-increase]');
    
    decreaseBtn.addEventListener('click', () => {
      let value = parseInt(input.value);
      if (value > 1) {
        input.value = value - 1;
      }
    });
    
    increaseBtn.addEventListener('click', () => {
      let value = parseInt(input.value);
      input.value = value + 1;
    });
    
    // Optional: Handle direct input validation
    input.addEventListener('input', () => {
      if (input.value < 1 || isNaN(input.value)) {
        input.value = 1;
      }
    });
  });
});